import React from 'react';
import 'antd/dist/antd.css';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';

import { Icon } from '../index';
import { icons } from '../../../constants/icons';
import { languages } from '../../../constants';
import robotIconBlack from '../../../images/robotIconBlack.png';

import style from './SideMenu.module.scss';

const { SubMenu } = Menu;

export const SideMenu = ({
  collapsed = false,
  onToggle,
  menuItems,
  Sider,
  language,
  SelectedKey = menuItems[0]?.key,
  openKeys,
  onOpenChange,
  onSelect
}) => {
  const toggle = () => {
    onToggle(!collapsed);
  };

  return (
    <Sider className={ style.sider } trigger={ null } collapsible collapsed={ collapsed }>
      <div className={ style.logo } />
      <div style={{ textAlign: 'center' }}>
        <Icon
          vendorClass={ style.trigger }
          svg="MENU"
          svgProps={{ width: '35', height: '35' }}
          onClick={ toggle }
        />
      </div>
      <Menu
        style={{ float: 'right' }}
        mode="inline"
        defaultSelectedKeys={ SelectedKey }
        openKeys={ openKeys }
        onOpenChange={ onOpenChange }
        onSelect={ onSelect }
      >
        {menuItems.map(item => {
                    if (!item) {
                        return null;
                    }
                    if (item.submenu) {
                        return (
                          <SubMenu
                            className={ style['main-title'] }
                            key={ item.key }
                            title={
                              <span className={ style.row }>
                                {item.iconType === icons.RobotOutlined
                                  ? (
                                    <img
                                      src={ robotIconBlack }
                                      alt="Robot"
                                      className={ style.icon }
                                      style={{
                                       width: '25px',
                                       height: '25px',
                                       marginRight: collapsed ? '0' : '12px',
                                       objectFit: 'contain'
                                      }}
                                    />
                                  )
                                  : (
                                <Icon
                                  svg={ icons[item.iconType] }
                                  vendorClass={ style.icon }
                                  svgProps={{ width: '25', height: '25' }}
                                />
                                  )}
                                <span>{item.title}</span>
                              </span>
                                }
                          >
                            {item.submenu.map(subItem => (
                              <Menu.Item
                                className={ style['sub-title'] }
                                onClick={ subItem.onClick }
                                key={ subItem.key }
                              >
                                <Link to={ subItem.key } id={ subItem.linkId ?? subItem.id }>
                                  <Icon
                                    vendorClass={ style['sub-icon'] }
                                    svg={ language === languages.EN ? 'MENU_R_ARROW' : 'MENU_L_ARROW' }
                                    svgProps={{ width: '10', height: '10' }}
                                  />

                                  <span>{subItem.title}</span>
                                </Link>
                              </Menu.Item>
                                ))}
                          </SubMenu>
                        );
                    }

                    return (
                      <Menu.Item
                        className={ style['main-title'] }
                        onClick={ item.onClick }
                        key={ item.key }
                      >
                        <Link
                          to={ !item?.submenu && item.key }
                          id={ !item?.submenu && (item.linkId ?? item.id) }
                        >
                          <span className={ style.row }>
                            {item.iconType === icons.RobotOutlined
                              ? (
                                <img
                                  src={ robotIconBlack }
                                  alt="Robot"
                                  className={ style.icon }
                                  style={{
                                   width: '32px',
                                   height: '32px',
                                   marginRight: collapsed ? '0' : '12px',
                                   objectFit: 'contain'
                                  }}
                                />
                              )
                              : (
                            <Icon
                              vendorClass={ style.icon }
                              svg={ icons[item.iconType] }
                                  svgProps={{ width: '32', height: '32' }}
                            />
                              )}
                            <span>{item.title}</span>
                          </span>
                        </Link>
                      </Menu.Item>
                    );
                })}
      </Menu>
    </Sider>
  );
};
